import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('customer-data-views-mangagement');
